import { render, staticRenderFns } from "./LoginManagerAccount.vue?vue&type=template&id=2bde0fc4&scoped=true&"
import script from "./LoginManagerAccount.vue?vue&type=script&lang=js&"
export * from "./LoginManagerAccount.vue?vue&type=script&lang=js&"
import style0 from "./LoginManagerAccount.vue?vue&type=style&index=0&id=2bde0fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde0fc4",
  null
  
)

component.options.__file = "LoginManagerAccount.vue"
export default component.exports